import e from "@dialpad/dialtone-tokens/layered/themes/tokens-paprika-colors.css?inline";
//#region themes/paprika.js
var t = {
	brand: {
		css: e,
		name: "paprika"
	},
	material: { name: "steel" }
};
//#endregion
export { t as default };
